import Vue from 'vue'
import taskCenter from './taskCenterDialog.vue'
import eventBus from '@/utils/eventBus'
const TaskCenter = Vue.extend(taskCenter)

export default {
  install(vue) {
    const ins = new TaskCenter()
    ins.$mount(document.createElement('div'))
    document.body.appendChild(ins.$el)
    // 打开弹框
    const open = bool => {
      console.log('任务中心打开')
      ins.visible = true
      ins.isVideoEdit = bool
      // 保证任务中心高于 el-drawer 等浮层（抽屉常见 z-index 为 2000~3000）
      ins.$nextTick(() => {
        if (ins.zIndex < 3100) {
          ins.zIndex = 3100
        }
      })
    }
    // 关闭弹框
    const close = () => {
      ins.visible = false
    }
    // 添加任务
    const addTask = obj => {
      ins.addTask(obj)
      open()
    }
    const setMenuKey = id => {
      ins.setMenuKey(id)
    }
    // 监听
    const on = (key, fn = () => {}) => {
      eventBus.$on(key, msg => fn(msg))
    }
    vue.prototype.$taskCenter = {
      open,
      close,
      addTask,
      on,
      setMenuKey
    }
  }
}
